var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 39.1C63.6 29.7 48.4 29.7 39.1 39.1C29.8 48.5 29.7 63.7 39 73.1L567 601.1C576.4 610.5 591.6 610.5 600.9 601.1C610.2 591.7 610.3 576.5 600.9 567.2L414.4 380.7L510.8 268.2L521.3 278.7C533.8 291.2 554.1 291.2 566.6 278.7C579.1 266.2 579.1 245.9 566.6 233.4L406.6 73.4C394.1 60.9 373.8 60.9 361.3 73.4C348.8 85.9 348.8 106.2 361.3 118.7L371.9 129.1L259.4 225.5L73 39.1zM135.6 237.4L134.2 238.1L131.4 239.5C122.1 244.1 115.7 252.8 114 263C112.3 273.2 115.7 283.5 123 290.8L349.3 517C356.6 524.3 366.9 527.6 377.1 526C387.3 524.4 396 517.9 400.6 508.7L402 505.9L402.7 504.5L135.6 237.4zM73.4 521.4C60.9 533.9 60.9 554.2 73.4 566.7C85.9 579.2 106.2 579.2 118.7 566.7L224.9 460.5L179.6 415.2L73.4 521.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpin);
export default __webpack_public_path__ + "static/media/icon-unpin.3dcdde95c533ce31440ecdd38620bc74.svg";
export { ForwardRef as ReactComponent };